import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../../../../ingredients/services";
import { Globals } from "../../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DishPartialIngredientsSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-partial-ingredients-selected',
  templateUrl: 'dish-partial-ingredients-selected.html',
})
export class DishPartialIngredientsSelectedPage {

  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public translate: TranslateService) {
  }

  delete(element) {
    var index = this.ingredientsServices.foodcost_array_tmp.findIndex(x => x[0] == element[0]);
    if (index >= 0) {
      this.ingredientsServices.foodcost_array_tmp.splice(index, 1);
      this.ingredientsServices.foodcost_array_tmp = [...this.ingredientsServices.foodcost_array_tmp];
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.delete(event.row);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-cost/dish-ingredients-select/dish-partial-ingredients-selected/dish-partial-ingredients-selected.ts